<h1 dialog-title> <b>Validar Convenio </b></h1> <br/>
<form #convenioValidarForm=ngForm>
    <mat-dialog-content>
        <p>
            <form-field appearance="outline" class="mat-input">
                <label> Solicitante </label>
                <br/> {{this.convenio.nombreUsuario}} ({{this.convenio.rutUsuario}})

            </form-field>
        </p>
        <p *ngIf="this.convenio.idCarga > 0">
            <form-field appearance="outline" class="mat-input">
                <label> Beneficiario </label>
                <br/> {{this.convenio.nombreCarga}} ({{this.convenio.rutCarga}})

            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">

                <label>Categoría de atención </label><br/>

                <select name="idTipoConvenio" id="idTipoConvenio" #idTipoConvenio="ngModel" [(ngModel)]="convenio.idTipoConvenio"  [disabled]="true" required>

                <option *ngFor="let categoria of this.data.categorias" value="{{categoria.id}}"  [disabled]="true">
                    {{categoria.descripcion}}
                </option>
            </select>

            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">
                <label> Monto Solicitado </label><br/>
                <input matInput type="number" class="form-control" value="this.convenio.montoSolicitado" id="montoSolicitado" name="montoSolicitado" [(ngModel)]="convenio.montoSolicitado" #montoSolicitado="ngModel" placeholder="Monto Máximo Disponible" max="convenio.totalMaximo" [disabled]="data.deshabilitado"
                    required>
            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">

                <label>Región </label><br/>

                <select class="form-control" id="idRegion" name="idRegion" required [(ngModel)]="convenio.idRegion" #idRegion="ngModel" [disabled]="true" required>

                <option  *ngFor="let region of this.data.regiones" value="{{region.id}}">
                    {{region.nombre}}
                </option>
            </select>

            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">

                <label>Proveedor </label><br/>
                <select [(ngModel)]="convenio.idProveedor" class="form-control" id="idProveedor" name="idProveedor" #idProveedor="ngModel" required [disabled]="true" required>

                <option  *ngFor="let proveedor of data.proveedores" value="{{proveedor.id}}">
                    {{proveedor.descripcion}}
                </option>
            </select>

            </form-field>
        </p>

        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Número de Presupuesto</mat-label><br/>

             
                <input matInput type="number" value="data.numPresupuesto" class="form-control" id="numPresupuesto" name="numPresupuesto" [(ngModel)]="data.numPresupuesto" #numPresupuesto="ngModel" placeholder="ingrese número de Presupuesto"  [disabled]="data.deshabilitado"
                required>

            </form-field>
        </p>



        <p>
            <form-field appearance="outline" class="mat-input">

                <label> Cantidad Cuotas </label><br/>
                <select class="form-control" id="cantidadCuota" name="cantidadCuota" [(ngModel)]="convenio.idCantidadCuota" #cantidadCuota="ngModel" required [disabled]="data.deshabilitado" required>
                
                <option *ngFor="let cuota of data.cuotas" value="{{cuota.id}}">

                    {{cuota.descripcion}}

                </option>
            </select>

            </form-field>
        </p>




        <p>
            <button class="btn btn-primary" id="btnCalcularPlanPago" name="btnCalcularPlanPago" (click)="calcularPlanPago()" [disabled]="data.deshabilitado">
                Calcular
        </button>
            <label> * Si cambia el monto solicitado o la cantidad de cuotas, debe presionar el botón para actualizar el plan de pago</label>
        </p>




        <p>
            <form-field appearance="outline" class="mat-input">
                <label> Monto Cuota a Pagar </label>
                <br/>&emsp;{{convenio.montoCuota}}
            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">
                <label> Fecha Primer Descuento</label>
                <br/>&emsp;{{convenio.fechaPrimerPago}}
            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">
                <label>Codeudores </label>
                <br/>
                <label>&emsp;{{this.convenio.nombreCodeudorUno}} ({{this.convenio.rutCodeudorUno}})</label> <br/>
                <label>&emsp;{{this.convenio.nombreCodeudorDos}} ({{this.convenio.rutCodeudorDos}}) </label>

            </form-field>
        </p>
 
        <p>
            <button *ngIf="this.convenio.tieneConvenioAdjunto>0" class="mat-raised-button btn-info" (click)="onDescargarConvenioArchivosClick(data.idPostulacion)">
        
                <i class = "fa fa-download"> </i> Ver Orden generada </button>
        </p>

        <p>
            <button class="mat-raised-button btn-info" (click)="onDescargarArchivosClick(data.idPostulacion)">
        
                <i class = "fa fa-download"> </i> Ver Archivo(s) Ingresado(s) </button>
        </p>
        

    </mat-dialog-content>

</form>
<br/>

<mat-dialog-actions>
    <div *ngIf="this.data.rol != 'ROLE_EJECUTIVO_CAIP';  else roleReadOnly">
        <button *ngIf="!this.data.presionaEditar && this.data.mostrarEditar && this.data.disponiblePago && this.data.mostrarAprobarButton" mat-button class="mat-raised-button btn-warning" (click)="onEditarPostulacionClick()"> 
            <i class ="fa fa-pen"> </i> Editar
        </button>

        <button *ngIf="!this.data.presionaEditar && this.data.mostrarEditar && this.data.mostrarAprobarButton" mat-button class="mat-raised-button btn-success" (click)="onAprobarPostulacionClick(data.idPostulacion,null)">
            <i class = "fa fa-check"> </i> Aprobar
        </button>


        <button *ngIf="!data.presionaEditar && data.mostrarEditar && data.disponiblePago &&data.mostrarAprobarButton" mat-button class="mat-raised-button btn-danger" (click)="onRechazarPostulacionClick(data.idPostulacion)">
            <i class = "fa fa-times"> </i> Rechazar
        </button>

        <button *ngIf="data.presionaEditar && data.mostrarEditar && data.disponiblePago" mat-button class="mat-raised-button btn-success" (click)="onGuardarClick(convenioValidarForm)">
            <i class = "fa fa-download"> </i> Guardar
        </button>
        <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </div>
    <ng-template #roleReadOnly>
        <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </ng-template>

</mat-dialog-actions>


<br/>